import Swiper from "swiper";
import { A11y, Navigation, Scrollbar } from "swiper/modules";
import "@/styles/components/slider.css";

const relatedPosts = document.querySelector(".related-posts");

document.addEventListener("DOMContentLoaded", () => {
  const container = relatedPosts.querySelector(".swiper");

  new Swiper(container, {
    modules: [A11y, Navigation, Scrollbar],
    speed: 500,
    navigation: {
      nextEl: relatedPosts.querySelector(".slider-button-next"),
      prevEl: relatedPosts.querySelector(".slider-button-prev"),
    },
    scrollbar: {
      el: relatedPosts.querySelector(".swiper-scrollbar"),
      draggable: true,
    },
    simulateTouch: false,
    slidesPerView: 1,
    spaceBetween: 24,
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 36,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 36,
      },
      1280: {
        slidesPerView: 3.5,
        spaceBetween: 36,
      },
      1536: {
        slidesPerView: 3.5,
        spaceBetween: 48,
      },
    },
  });
});
